import React from 'react'

import { Check as CheckIcon } from 'react-feather'
import {
  Box,
  Button,
  Grid,
  MenuItem,
  TextField,
  Typography,
} from '@material-ui/core'
import { KeyboardDatePicker } from '@material-ui/pickers'
import { Controller, useForm } from 'react-hook-form'

import helpers from 'helpers'
import * as service from 'service'
import constants from 'constants/index'

import schema from './schema'
import useStyles from './styles'

import useSnackbar from 'hooks/useSnackbar'

const ExpirationEditForm = ({ consentForm }) => {
  const snackbar = useSnackbar()
  const classes = useStyles()

  const { errors, control, handleSubmit } = useForm({
    validationSchema: schema(),
    mode: 'onBlur',
    defaultValues: {
      dueDate: consentForm?.dueDate,
      expirationTime: consentForm?.expirationConfig?.expirationTime,
      expirationUnit:
        constants.consent.EXPIRATION_UNITS[
          consentForm?.expirationConfig?.expirationUnit
        ],
    },
  })

  const onSubmit = async (data) => {
    data.dueDate = helpers.formatters.date(data?.dueDate)

    try {
      await service.dponet.consent.updateExpirationConfig({
        consentFormId: consentForm?.id,
        consentForm: data,
      })

      snackbar.open({
        message: 'Data de validade alterada com sucesso.',
        variant: 'success',
      })
    } catch (error) {
      snackbar.open({
        message:
          helpers.formatters.errorMessage(error, false) ||
          error?.error?.message,
        variant: 'error',
      })
    }
  }

  const consentAlreadyCollected = consentForm?.answersCollected.total > 0
  const formAlreadyExpired =
    consentForm?.status === constants.consent.EXPIRED_STATUS_ID

  const expirationType =
    constants.consent.EXPIRATION_TYPES[
      consentForm?.expirationConfig?.expirationType
    ]

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Box className={classes.warningBox} mb={4}>
            <Typography>
              <strong>Atenção:</strong>{' '}
              {consentForm?.answersCollected?.total > 0
                ? 'Não é possível editar a data de vencimento pois houve coleta de assinatura.'
                : 'Não será possível editar a data de vencimento após a coleta de assinaturas.'}
            </Typography>
          </Box>

          {expirationType === constants.consent.FORM_TYPE ? (
            <Controller
              as={
                <KeyboardDatePicker
                  fullWidth
                  format="DD/MM/yyyy"
                  label="Escolha a data de vencimento"
                  inputVariant="outlined"
                  error={!!errors?.dueDate}
                  helperText={errors?.dueDate?.message}
                  disablePast
                  clearable
                  disabled={consentAlreadyCollected || formAlreadyExpired}
                />
              }
              control={control}
              onChange={([date]) => date}
              name="dueDate"
            />
          ) : (
            <Grid container spacing={1}>
              <Grid item xs={6}>
                <Controller
                  as={
                    <TextField
                      error={!!errors?.expirationTime}
                      helperText={errors?.expirationTime?.message}
                      label="Escolha o tempo de validade"
                      variant="outlined"
                      fullWidth
                      disabled={consentAlreadyCollected}
                    />
                  }
                  control={control}
                  name="expirationTime"
                  mode="onBlur"
                />
              </Grid>
              <Grid item xs={6}>
                <Controller
                  as={
                    <TextField
                      select
                      label="Escolha a unidade do tempo de validade"
                      fullWidth
                      error={!!errors.expirationUnit}
                      helperText={errors.expirationUnit?.message}
                      disabled={consentAlreadyCollected}
                    >
                      <MenuItem value={constants.consent.DAY_UNIT}>
                        Dias
                      </MenuItem>
                      <MenuItem value={constants.consent.MONTH_UNIT}>
                        Meses
                      </MenuItem>
                      <MenuItem value={constants.consent.YEAR_UNIT}>
                        Anos
                      </MenuItem>
                    </TextField>
                  }
                  control={control}
                  name="expirationUnit"
                  mode="onBlur"
                />
              </Grid>
            </Grid>
          )}
        </Grid>
        <Grid item xs={12}>
          <Box textAlign="right">
            <Button
              type="submit"
              variant="contained"
              color="primary"
              startIcon={<CheckIcon />}
              disabled={consentAlreadyCollected || formAlreadyExpired}
            >
              Salvar
            </Button>
          </Box>
        </Grid>
      </Grid>
    </form>
  )
}

export default ExpirationEditForm
